import BasicRouterView from "../../components/BasicRouterView.vue";

const ferramentasAdmRoutes = {
  path: "fer",
  redirect: { name: "cadastrarFerramenta" },
  meta: {
    label: "Ferramentas - Adm",
    icon: "handyman",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "ferramenta/cadastrar-ferramenta",
      name: "cadastrarFerramenta",
      meta: {
        label: "Cadastrar Ferramenta",
        icon: "handyman",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/CadastrarFerramentas.vue"
        ),
    },
    {
      path: "ferramenta/cadastrar-ferramenta-massa",
      name: "cadastrar-ferramenta-massa",
      meta: {
        label: "Cadastrar Ferramentas Em Massa",
        icon: "plumbing",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/CadastrarFerramentasMassa.vue"
        ),
    },
    {
      path: "ferramenta/editar-ferramenta/:uuid",
      name: "editarFerramenta",
      meta: {
        label: "Editar",
        icon: "edit",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/EditarFerramenta.vue"),
    },
    {
      path: "ferramenta/retirar-ferramenta",
      name: "retirarFerramenta",
      meta: {
        label: "Retirada",
        icon: "arrow_back",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/RetirarFerramenta.vue"),
    },
    {
      path: "ferramenta/devolver-ferramenta",
      name: "devolverFerramenta",
      meta: {
        label: "Devolução",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/DevolverFerramenta.vue"),
    },

    {
      path: "ferramenta/movimentar-status-ferramenta",
      name: "movimentarStatusFerramenta",
      meta: {
        label: "Movimentar Status",
        icon: "build",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/MovimentarStatusFerramenta.vue"
        ),
    },
    {
      path: "ferramenta/movimentar-status-ferramenta-detalhe/:id",
      name: "movimentarStatusFerramentaDetalhes",
      meta: {
        label: "Movimentar Status",
        icon: "build",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/movimentarStatusFerramentaDetalhes.vue"
        ),
    },
    {
      path: "ferramenta/transferencia-ferramenta",
      name: "trasnferenciaFerramentas",
      meta: {
        label: "Criar Transferência",
        icon: "compare_arrows",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/TransferenciaFerramentas.vue"
        ),
    },
    {
      path: "ferramenta/qr-code",
      name: "FerramentasQr",
      meta: {
        label: "Ferramentas Checkagem",
        icon: "compare_arrows",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/FerramentasQr.vue"),
    },
    {
      path: "ferramenta/imprimir-etiqueta/:nome/:patrimonio/:codigo",
      name: "imprimir-etiqueta-ferramenta",
      meta: {
        label: "Imprimir",
        icon: "qr_code_scanner",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "produtos" */ "./views/ImprimirEtiqueta.vue"
        ),
    },
    //{
    //path: "manutencaoFerramentas",
    //name: "manutencaoFerramentas",
    //meta: {
    //label: "Necessidade de Manutenção",
    //icon: "compare_arrows",
    //show: true,
    //},
    //component: () =>
    //import(
    // /* webpackChunkName: "pdt" */ "./ferramentasAdm/views/ManutencaoFerramentas.vue"
    //),
    //},
    //{
    //path: "manutencaoDetalhes/:id",
    //name: "manutencaoDetalhes",
    //meta: {
    //label: "Necessidade de Manutenção",
    //icon: "compare_arrows",
    //show: false,
    //},
    //component: () =>
    //import(
    // /* webpackChunkName: "pdt" */ "./ferramentasAdm/views/ManutencaoFerramentasDetalhes.vue"
    //),
    //},
    {
      path: "ferramenta/detalhe-transferencia/:id",
      name: "detalheTransferencia",
      meta: {
        label: "Criar Transferência",
        icon: "build",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/DetalheTransferencia.vue"
        ),
    },
    {
      path: "ferramenta/imprimir-transferencia/:id",
      name: "imprimirTransferencia",
      meta: {
        label: "Criar Transferência",
        icon: "build",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/ImprimirTransferencia.vue"
        ),
    },
    {
      path: "ferramenta/relatorio-ferramenta",
      name: "RelatorioFerramentas",
      meta: {
        label: "Relatório de Ferramentas",
        icon: "assignment",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/RelatorioFerramentas.vue"
        ),
    },
    {
      path: "ferramenta/relatorio-movimentacao",
      name: "RelatorioMovimentacoes",
      meta: {
        label: "Relatório de Movimentacoes",
        icon: "assignment_return",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/RelatorioMovimentacoes.vue"
        ),
    },
    {
      path: "ferramenta/relatorio-status",
      name: "RelatorioStatus",
      meta: {
        label: "Relatório de Status",
        icon: "task",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/RelatorioStatus.vue"),
    },
    {
      path: "ferramenta/relatorio-cautela",
      name: "relatorioCautela",
      meta: {
        label: "Relatório de Cautela",
        icon: "print",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/RelatorioCautela.vue"),
    },
    {
      path: "ferramenta/cadastrar-grupo",
      name: "cadastrarGrupo",
      meta: {
        label: "Cadastrar Grupo",
        icon: "group_add",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/CadastrarGrupos.vue"),
    },
    {
      path: "ferramenta/editar-grupo/:uuid",
      name: "editarGrupo",
      meta: {
        label: "Editar Grupo",
        icon: "edit",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/EditarGrupo.vue"),
    },
    {
      path: "ferramenta/detalhar-grupo/:uuid/:unidadeId",
      name: "detalhar-grupo",
      meta: {
        label: "Detalhar Grupo",
        icon: "edit",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/DetalharGrupo.vue"),
    },
    {
      path: "ferramenta/checklist",
      name: "checklist",
      meta: {
        label: "Checklist",
        icon: "checklist",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/Checklist.vue"),
    },
    {
      path: "ferramenta/lista-usuario-associacao",
      name: "listaUsuariosAssosiacao",
      meta: {
        label: "Associações",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/AssociaçãoUsuario.vue"),
    },
    {
      path: "ferramenta/associar-usuario-ferramenta",
      name: "assosiarUsuarioFerramenta",
      meta: {
        label: "Associar Usuario/Ferramenta",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/Assosiar.vue"),
    },
    {
      path: "ferramenta/associar-ferramenta-usuario",
      name: "assosiarFerramentaUsuario",
      meta: {
        label: "Associar Ferramenta/Usuarios",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./views/AssosiarConjuntoUsuarios.vue"
        ),
    },
    {
      path: "ferramenta/associar-checklist",
      name: "assosiarChecklist",
      meta: {
        label: "Associar Checklist",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/AssosiarCheklist.vue"),
    },
    {
      path: "ferramenta/imprimir/:nome",
      name: "imprimir",
      meta: {
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/Imprimir.vue"),
    },
    {
      path: "ferramenta/configurar-ficha-cautela",
      name: "configurar-ficha-cautela",
      meta: {
        label: "Customização de Ficha Cautela",
        icon: "fact_check",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "cse" */ "./views/ConfiguracaoFichaCautela.vue"
        ),
    },

    //Telas modificadas para a vale com mudanças de nomeclatura, ferramenta -> item.
    {
      path: "ferramenta/associar-checklist-vale",
      name: "associar-checklist-vale",
      meta: {
        label: "Associar Checklist",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/AssociarCheklistVale.vue"
        ),
    },

    {
      path: "ferramenta/associar-ferramenta-usuario-vale",
      name: "associar-ferramenta-usuario-vale",
      meta: {
        label: "Associar Itens/Usuarios",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/AssociarConjuntoUsuariosVale.vue"
        ),
    },

    {
      path: "ferramenta/associar-usuario-ferramenta-vale",
      name: "associar-usuario-ferramenta-vale",
      meta: {
        label: "Associar Usuario/Item",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "fer" */ "./views/AssociarVale.vue"),
    },
    {
      path: "ferramenta/cadastrar-ferramenta-vale",
      name: "cadastrar-ferramenta-vale",
      meta: {
        label: "Cadastrar Item",
        icon: "handyman",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/CadastrarFerramentasVale.vue"
        ),
    },
    {
      path: "ferramenta/editar-ferramenta-vale/:uuid",
      name: "editar-ferramenta-vale",
      meta: {
        label: "Editar Item",
        icon: "edit",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/EditarFerramentaVale.vue"
        ),
    },
    {
      path: "ferramenta/checklist-vale",
      name: "checklist-vale",
      meta: {
        label: "Checklist",
        icon: "checklist",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "fer" */ "./views/ChecklistVale.vue"),
    },

    {
      path: "ferramenta/devolver-ferramenta-vale",
      name: "devolver-ferramenta-vale",
      meta: {
        label: "Devolução",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/DevolverFerramentaVale.vue"
        ),
    },

    {
      path: "ferramenta/lista-usuario-associacao-vale",
      name: "listar-usuario-associacao-vale",
      meta: {
        label: "Associações",
        icon: "arrow_forward",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/AssociacaoUsuarioVale.vue"
        ),
    },

    {
      path: "ferramenta/relatorio-ferramenta-vale",
      name: "relatorio-ferramenta-vale",
      meta: {
        label: "Relatório de Itens",
        icon: "assignment",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/RelatorioFerramentasVale.vue"
        ),
    },

    {
      path: "ferramenta/relatorio-movimentacao-vale",
      name: "relatorio-movimentacao-vale",
      meta: {
        label: "Relatório de Movimentacoes",
        icon: "assignment_return",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/RelatorioMovimentacoesVale.vue"
        ),
    },

    {
      path: "ferramenta/retirar-ferramenta-vale",
      name: "retirar-ferramenta-vale",
      meta: {
        label: "Retirada",
        icon: "arrow_back",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "fer" */ "./views/RetirarFerramentaVale.vue"
        ),
    },

    {
      path: "ferramenta/qr-code-vale",
      name: "qr-code-vale",
      meta: {
        label: "Checagem Itens",
        icon: "compare_arrows",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./views/FerramentasQrVale.vue"),
    },
  ],
};

export default ferramentasAdmRoutes;
